import {Component, ChangeDetectorRef, ElementRef, OnInit, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {UtilityService} from '../../../services/utility-service';
import {ApiService} from '../../../services/api.service';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { Location} from '@angular/common';
import { Constants } from '../../../constants/ebtq-constants';
import { TransactionDetailsWrapperList } from '../../../model/models';
import { TransactionWrapperData } from '../../../model/transactionWrapperData';
import {Title} from '@angular/platform-browser';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-query-transactions-results',
  templateUrl: './query-transactions-results.component.html',
  styleUrls: ['./query-transactions-results.component.scss']
})
export class QueryTransactionsResultsComponent implements OnInit, OnDestroy {

  private errorSub: Subscription;
  responseTransList: TransactionDetailsWrapperList;
  transIdList: any[] = [];
  transactionDataList: any[] = [];
  cols: any[];
  printCols: any[];
  displayCols: any[];
  containsError = false;
  deleteEnableCheckboxFlag = false;
  errorMsg: string;
  routingForCancel: string;
  navigate: boolean;
  keys: any[];
  mainPage: string;
  transKeys: TransactionWrapperData[];
  loanResultKeys: any;
  internalUpdateRoleFlag: string;
  externalUpdateRoleFlag: string;
  isAdminrole: string;
  selectedPageView: string;
  noTranSel: string;
  subPage: string;
  pageView = [{label: 'Printable View', value: 'printView'},
    {label: 'Download To Excel', value: 'downloadtoExcel'}];
  title = 'List of Transactions';

  @ViewChildren('deleteCheckbox')
    deleteCheckboxes: QueryList<ElementRef>;

  constructor(private activeRouter: ActivatedRoute, private router: Router,
              private service: ApiService, private errorService: ErrorService,
              private location: Location, private utilService: UtilityService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    /**  Call routing Query params */
    this.fetchRecords();
    this.selectedPageView = 'printView';
  }

  /** Define the column header */
  ngOnInit() {
    this.titleService.setTitle(this.title);
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    this.externalUpdateRoleFlag = sessionStorage.getItem('isRMExternal_Servicing_Update');

    this.internalUpdateRoleFlag = sessionStorage.getItem('isRMInternal_Update');
    this.isAdminrole = sessionStorage.getItem('isAdmin');
    this.isDeleteEnabledOrNot();


    this.cols = [
      {field: 'delete', header: 'Delete ?'},
      {field: 'servicerNum', header: 'Servicer Number'},
      {field: 'loanNumber', header: 'Loan Number'},
      {field: 'effectiveDate', header: 'Effective Date'},
      {field: 'actionCode', header: 'Action Code'},
      {field: 'tranDesignator', header: 'Transaction Description'},
      {field: 'transactionAmt', header: 'Trans Amount'},
      {field: 'reversedFlag', header: 'Reversed'},
      {field: 'tranSysKey', header: 'Trans ID'},
      {field: 'productType', header: 'Product Type'},
      {field: 'receiptDate', header: 'Receipt Date'},
      {field: 'transStatus', header: 'Transaction Status'},
      {field: 'tranType', header: 'Transaction Type'}
    ];


    this.printCols = [

      {field: 'servicerNum', header: 'Servicer Number'},
      {field: 'loanNumber', header: 'Loan Number'},
      {field: 'effectiveDate', header: 'Effective Date'},
      {field: 'actionCode', header: 'Action Code'},
      {field: 'tranDesignator', header: 'Transaction Description'},
      {field: 'transactionAmt', header: 'Trans Amount'},
      {field: 'reversedFlag', header: 'Reversed'},
      {field: 'tranSysKey', header: 'Trans ID'},
      {field: 'productType', header: 'Product Type'},
      {field: 'receiptDate', header: 'Receipt Date'},
      {field: 'transStatus', header: 'Transaction Status'},
      {field: 'tranType', header: 'Transaction Type'}
    ];

    this.displayCols = this.displayColumns();
    this.cdr.detectChanges();
  }
  /** Onclick - navigate to Loan Detail page by loadID */
  public showLoanDetails(data: any) {
    this.loanDetails(data.loanNumber);
  }
  public showTransactionDetails(data: any) {
    this.transactionDetails(data.tranSysKey);
  }


  selectAll()
  {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      if (!(<any>deleteCheckbox).disabled) {
        (<any>deleteCheckbox).checked = true;
      }
    });

  }


  unSelectAll()
  {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      (<any>deleteCheckbox).checked = false;
    });
  }

  displayColumns() {

    return this.cols.filter(col =>{
      if (!this.deleteEnableCheckboxFlag)
      {
        return col.field !== 'delete';
      }
      return true;
    }).map(col => col);



  }

  /**  Fetch records based on the routing Query params from Server */
  fetchRecords(): void {

    let data;
    this.activeRouter.queryParams.subscribe(params => {
      data = JSON.parse(atob(params.query));
      this.loanResultKeys = params.loanResult;
      this.navigate = params.navigate;
      this.mainPage = params.mainPage;
      this.transKeys = params.query;
      this.subPage = params.subPage;
      if (params.keys !== undefined) {
        this.keys = params.keys;
      }
      else {
        this.keys = data;
      }
    });

    let transactionWrapper = new TransactionWrapper();
    let transactionWrapperData = new TransactionWrapperData;
    transactionWrapperData = data;
    transactionWrapper = transactionWrapperData.transactionWrapper;
    this.routingForCancel = transactionWrapperData.callingServiceName;
    transactionWrapper.queryServiceName = Constants.GET_TRAN_QUERY_DATA_FOR_PKS;

    /** Request  transactions list **/
    this.service.requestTransDetails(transactionWrapper).subscribe(
      (data: TransactionDetailsWrapperList) => {
        this.responseTransList = data;
        /** Called updateUIValue method to update key to Label values */
        this.responseTransList = this.convertValueToLabel(this.responseTransList);
        this.cdr.detectChanges();
      },
      error => {
        this.errorService.announceError(error);
      }
    );
    this.errorAnnouncement();

  }

  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }

  onCancel() {
    if (this.mainPage === 'queryTransactions') {
      this.router.navigate([this.routingForCancel]);
    }
    else if (this.mainPage === 'transactions') {
      const navigationExtras : NavigationExtras = {
        queryParams: {subPage:this.subPage}
      };
      this.router.navigateByUrl(this.mainPage, navigationExtras);
    }
    else {
      this.router.navigate(['queryLoansDetails'], {
        queryParams: { loanNumber:this.navigate, query: this.keys, mainPage: this.mainPage, loanResult: this.loanResultKeys }
      });
    }
  }

  /** convertValueToLabelAndDate method implemented to update key to Label values */
  convertValueToLabel(entity: TransactionDetailsWrapperList): any {

    entity.forEach(function(part, index, array) {

      const utilityService = new UtilityService();

      /** Get the label value from utilService */
      utilityService.actionTypeCode.forEach(function(part1, index1, array1) {
        if (array1[index1].value === String(array[index].actionCode)) {
          array[index].actionCode = array1[index1].label;
        }
      });

      /** Get the label value from utilService */
      utilityService.productCode.forEach(function(part1, index1, array1) {
        if (array1[index1].value === String(array[index].productType)) {
          array[index].productType = array1[index1].label;
        }
      });

      /** Get the label value from utilService */
      utilityService.transactionDesignatorTypeCode.forEach(function(part1, index1, array1) {
        if (array1[index1].value === String(array[index].tranDesignator)) {
          array[index].tranDesignator = array1[index1].label;
        }
      });

      /** Get the label value from utilService */
      utilityService.transactionStatusType.forEach(function(part1, index1, array1) {
        if (array1[index1].value === String(array[index].transStatus)) {
          array[index].transStatus = array1[index1].label;
        }
      });

      /** Get the label value from utilService */
      utilityService.tranType.forEach(function(part1, index1, array1) {
        if (array1[index1].value === String(array[index].tranType)) {
          array[index].tranType = array1[index1].label;
        }
      });

    });
    return entity;
  }
  /** Navigate to Loan detailed page */
  public loanDetails(inputLoanNumber: any) {
    this.router.navigate(['queryLoansDetails'], {
      queryParams: {loanNumber: inputLoanNumber, query: this.keys, mainPage: this.mainPage}
    });
  }
  /** Navigate to Transaction detailed page */
  public transactionDetails(inputTransactionNumber: any) {
    this.router.navigate(['queryTransactionDetails'], {
      queryParams: {transactionNumber: inputTransactionNumber, loanNumber:this.navigate, query: this.transKeys, mainPage: this.mainPage, loanResult: this.loanResultKeys}
    });
  }

  public deleteTransactions()
  {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      if ((<any>deleteCheckbox).checked)
      {
        const transactionData = (( <any>deleteCheckbox).value);

        this.transIdList.push(transactionData.tranSysKey);
        this.transactionDataList.push(transactionData);

        //this.deleteServiceTransferList.push((<any>deleteCheckbox).value);
      }

      if (this.transactionDataList != null && this.transactionDataList.length > 0)
      {
        this.service.setTransactionList(this.transactionDataList);
        this.router.navigate(['/confirmDeleteTrans']);

      } else {
        this.noTranSel = 'No Transactions selected for Delete.';
      }


    });

  }


  isDeleteEnabledOrNot() {
    if (this.externalUpdateRoleFlag === 'true' || this.isAdminrole === 'true'
      || this.internalUpdateRoleFlag === 'true')
    {
      this.deleteEnableCheckboxFlag = true;
    }
  }
  public pageViewAction(event: any) {
    if (this.selectedPageView === 'downloadtoExcel') {
      event.exportCSV();
    }
    if (this.selectedPageView === 'printView')
    {

      const printDetailsMap = new Map();
      printDetailsMap.set('title', 'List Of Transactions');
      printDetailsMap.set('columns', this.printCols);
      printDetailsMap.set('data', this.responseTransList);

      this.utilService.printViewData(printDetailsMap);
      this.router.navigate(['print']);
    }
  }
}
